import { Loader } from '@googlemaps/js-api-loader';

class LocationsMap {
	constructor(blockEl) {
		this.blockEl = blockEl;
		this.markers = [];
		this.map = null;
		this.initMap();
		this.setUpEventHandlers();
	}

	initMap() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop)
		});
		const filterState = params.state;
		const filterFacilityType = params.facility_type;

		const loader = new Loader({
			apiKey: 'AIzaSyCDr4boi4Op2xQy-c3ApSY7PzI9cDHQP9c',
			version: 'weekly'
		});

		loader.load().then(() => {
			this.map = new google.maps.Map(document.getElementById('locations-map'), {
				center: { lat: 39.8097343, lng: -98.5556199 },
				zoom: 4,
				mapTypeControl: false,
				fullscreenControl: false,
				mapTypeControlOptions: {
					mapTypeIds: ['styled_map']
				}
			});
			const soleoMapStyle = new google.maps.StyledMapType(
				[
					{
						featureType: 'administrative.land_parcel',
						elementType: 'geometry.fill',
						stylers: [
							{
								visibility: 'simplified'
							}
						]
					},
					{
						featureType: 'administrative.land_parcel',
						elementType: 'geometry.stroke',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'administrative.land_parcel',
						elementType: 'labels',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'landscape.natural',
						elementType: 'geometry',
						stylers: [
							{
								color: '#ffffff'
							}
						]
					},
					{
						featureType: 'poi',
						elementType: 'labels.text',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'poi.business',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'road',
						elementType: 'labels.icon',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'road.arterial',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'road.highway',
						elementType: 'labels',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'road.local',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'road.local',
						elementType: 'labels',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'transit',
						stylers: [
							{
								visibility: 'off'
							}
						]
					},
					{
						featureType: 'water',
						elementType: 'geometry.fill',
						stylers: [
							{
								color: '#3767a8'
							}
						]
					}
				],
				{ name: 'Columbia' }
			);
			this.map.mapTypes.set('styled_map', soleoMapStyle);
			this.map.setMapTypeId('styled_map');
			var base_url = window.location.origin;

			fetch(base_url + '/wp-json/wp/v2/location?per_page=100')
				.then((response) => {
					return response.json();
				})
				.then((res) => {
					res.forEach((location) => {
						if (
							location.ACF.hasOwnProperty('location_lat') &&
							location.ACF.hasOwnProperty('location_lon')
						) {
							const latLng = {
								lat: +location.ACF.location_lat,
								lng: +location.ACF.location_lon
							};
							const newMarker = new google.maps.Marker({
								title: location.title.rendered,
								position: latLng,
								postTarget: location.id,
								cardMarkup: location.card_markup,
								icon: {
									url: '../../wp-content/themes/columbia/media/images/map-marker-orange.png'
								}
							});
							newMarker.addListener('click', (e) => {
								document.getElementById('location-map-card').innerHTML =
									newMarker.cardMarkup;
							});
							this.markers.push(newMarker);
						}
					});
					this.setMap(this.map, filterState, filterFacilityType);
				});
		});
	}

	setUpEventHandlers() {}

	setMap(googleMap) {
		for (let i = 0; i < this.markers.length; i++) {
			this.markers[i].setMap(googleMap);
		}
	}
}

export default LocationsMap;
